import SelectAllButton from '../../common/components/List/SelectAllButton.js'
import {
  setSelectedTransferIDs,
  transferIDListSelector,
  indeterminateSelectedSelector,
  allSelectedSelector,
} from './transferListFunctions.js'
import {useSelector} from '../../store.js'

export default function TransferSelectAllButton() {
  const transferIDList = useSelector(transferIDListSelector)
  const indeterminate = useSelector(indeterminateSelectedSelector)
  const checked = useSelector(allSelectedSelector)

  return (
    <SelectAllButton
      checked={checked}
      indeterminate={indeterminate}
      onChange={(value) => setSelectedTransferIDs(value ? transferIDList : [])}
    />
  )
}
